module.exports = __webpack_public_path__ + "static/media/undraw_taken.9d420fb2.svg";